var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.occupation
    ? _c(
        "div",
        { staticClass: "room-modal-order__tourists" },
        [
          _vm._l(_setup.occupation.list, function (opt) {
            return _c(
              "label",
              { key: opt.adultChild, staticClass: "custom-radio" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _setup.occrec,
                      expression: "occrec",
                    },
                  ],
                  attrs: { type: "radio", name: "occupation_list" },
                  domProps: {
                    value: opt.adultChild,
                    checked: _vm._q(_setup.occrec, opt.adultChild),
                  },
                  on: {
                    change: function ($event) {
                      _setup.occrec = opt.adultChild
                    },
                  },
                }),
                _vm._v(
                  "\n        " + _vm._s(_setup.vzros(opt.adult)) + "\n        "
                ),
                opt.child
                  ? _c(
                      "span",
                      [
                        _vm._v(
                          "\n            + " +
                            _vm._s(_setup.rebenok(opt.child)) +
                            "\n            ("
                        ),
                        _c(_setup.SinceTill, {
                          attrs: { agesLine: _setup.occupation.ages.child },
                        }),
                        _vm._v(")\n        "),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _setup.occupation.ages.infant.till
            ? _c(
                _setup.MyCheckbox,
                {
                  staticClass: "room-modal-order__checkbox",
                  attrs: { choosed: _setup.infant_str },
                  on: { input: _setup.set_infant },
                },
                [
                  _c(
                    "span",
                    { attrs: { title: _setup.occupation.ages.infant.src } },
                    [
                      _vm._v("Добавить в каюту ребенка "),
                      _c(_setup.SinceTill, {
                        attrs: { agesLine: _setup.occupation.ages.infant },
                      }),
                      _vm._v(" без места и питания"),
                    ],
                    1
                  ),
                ]
              )
            : _c("div", { staticClass: "room-modal-order__checkbox" }, [
                _vm._v(
                  "\n        В данном круизе бронирование детей возможно "
                ),
                _c(
                  "span",
                  { attrs: { title: _setup.occupation.ages.infant.src } },
                  [_vm._v("только с местом")]
                ),
              ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }